/**
 * Guess an airline ICAO code from a callsign — the frontend fallback used when
 * the backend sent no airline_icao. Mirrors the backend's
 * CallsignAirlineResolver so both sides agree on when a callsign is NOT a
 * commercial flight identifier:
 *
 *  - military aircraft: tactical callsigns (NORSE, DUKE12, RRR7413) only
 *    coincidentally start with an airline code, so never guess for them;
 *  - the callsign is the registration (M-ASBA squawks "MASBA", whose first
 *    three letters are Malaysia Airlines), or looks like one;
 *  - anything that isn't three letters followed by a digit (RYR1234).
 *
 * Callers still check hasAirlineLogo() on the result before using it.
 */

function normalise(s) {
  return String(s).trim().toUpperCase().replace(/[\s-]/g, '');
}

/**
 * @param {string} callsign
 * @param {{registration?: string, military?: boolean}} [context]
 * @returns {string|null} three-letter airline code, or null
 */
export function airlineCodeFromCallsign(callsign, { registration, military } = {}) {
  if (!callsign) return null;
  if (military === true) return null;

  const cs = normalise(callsign);
  if (cs.length < 4) return null;
  if (registration && cs === normalise(registration)) return null;

  // Registration-shaped: N-number, all letters (GABCD), or not 3 letters + digit.
  if (/^N[0-9]/.test(cs)) return null;
  if (/^[A-Z]+$/.test(cs)) return null;
  if (!/^[A-Z]{3}[0-9]/.test(cs)) return null;

  return cs.substring(0, 3);
}

export default airlineCodeFromCallsign;
